import * as React from "react";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/en";
import utc from "dayjs/plugin/utc";
import {
  DatePicker,
  LocalizationProvider,
  type DateValidationError,
  type PickerChangeHandlerContext,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

dayjs.extend(utc);

interface IEnhancedDatePickerProps {
  value: Dayjs | null;
  onChange: (value: Dayjs | null, context: PickerChangeHandlerContext<DateValidationError>) => void;
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  error?: boolean;
  disabled?: boolean;
  onBlur?: () => void;
  required?: boolean;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  onError?: (error: DateValidationError, value: Dayjs | null) => void;
  clearable?: boolean;
  onClear?: () => void;
}

export const EnhancedDatePicker: React.FC<IEnhancedDatePickerProps> = (props) => {
  const {
    value,
    onChange,
    label,
    helperText,
    error,
    disabled,
    onBlur,
    required,
    maxDate,
    minDate,
    onError,
    clearable,
    onClear,
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      <DatePicker
        disabled={disabled}
        value={value}
        onChange={onChange}
        maxDate={maxDate}
        minDate={minDate}
        label={label}
        timezone="system"
        slotProps={{
          popper: {
            style: { zIndex: 10000 },
            onBlur: () => {
              if (onBlur) onBlur();
            },
          },
          desktopPaper: {
            variant: "outlined",
          },

          textField: {
            fullWidth: true,
            error: error,
            helperText: error ? helperText : "",
            size: "small",
            required: required,
            onBlur: () => {
              if (onBlur) onBlur();
            },
          },
          openPickerButton: {
            size: "small",
          },
          field: {
            clearable: clearable,
            onClear: () => onClear && onClear(),
          },
        }}
        sx={{
          zIndex: 1500,
          "& .MuiSvgIcon-root": {
            fontSize: "16px",
          },
        }}
        onError={onError}
      />
    </LocalizationProvider>
  );
};
